import { render, staticRenderFns } from "./ExportComponent.vue?vue&type=template&id=58b64b24&scoped=true&"
import script from "./ExportComponent.vue?vue&type=script&lang=js&"
export * from "./ExportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExportComponent.vue?vue&type=style&index=0&id=58b64b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b64b24",
  null
  
)

export default component.exports